/** Convierte texto tipeado (solo dígitos) a monto: "1"→0.01, "111"→1.11, "100001"→1000.01 */
export function parseCurrencyInput(value) {
  const digits = String(value ?? '').replace(/\D/g, '');
  if (!digits) return 0;
  return Math.round(parseInt(digits, 10)) / 100;
}

/** Formatea monto para input: 0.01→"0,01", 1000.01→"1.000,01" */
export function formatCurrencyInput(amount) {
  const cents = Math.round((parseFloat(amount) || 0) * 100);
  if (cents === 0) return '0,00';
  const digits = String(cents);
  const padded = digits.length < 3 ? digits.padStart(3, '0') : digits;
  const intPart = padded.slice(0, -2) || '0';
  const decPart = padded.slice(-2);
  const intFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${intFormatted},${decPart}`;
}
